import { observer } from 'mobx-react-lite'
import { type ApprovedTransactionViewModel } from '@/features/payouts/admin/review/ApprovedTransactionViewModel'
import { ApprovedTransaction } from '@/features/payouts/admin/review/components/DraftingView/ApprovedTransaction'

export interface ApprovedTransactionContainerProps {
  isDisabled: boolean
  vm: ApprovedTransactionViewModel
}

export const ApprovedTransactionContainer = observer(
  function ApprovedTransactionContainer({
    isDisabled,
    vm,
  }: ApprovedTransactionContainerProps) {
    return (
      <ApprovedTransaction
        isDisabled={isDisabled}
        isPending={vm.remove.pending}
        recipientName={vm.transaction.recipient.displayName}
        amount={vm.transaction.amount}
        source={vm.transaction.source}
        reason={vm.transaction.reason}
        jobId={vm.transaction.jobId ?? null}
        onRemove={vm.remove}
      />
    )
  },
)
